var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotypeLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650.8 243.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:.35em;}.cls-2{letter-spacing:.03em;}.cls-2,.cls-3{font-size:188.31px;}.cls-2,.cls-3,.cls-4{fill:#fff;}.cls-2,.cls-4{font-family:Panton-Trial-Bold, Panton-Trial;font-weight:700;}.cls-5{letter-spacing:.38em;}.cls-6{letter-spacing:.38em;}.cls-7{letter-spacing:.36em;}.cls-8{letter-spacing:.36em;}.cls-9{letter-spacing:.37em;}.cls-3{font-family:Panton-Trial-Heavy, Panton-Trial;font-weight:800;letter-spacing:.03em;}.cls-10{letter-spacing:.32em;}.cls-4{font-size:58.44px;}.cls-11{letter-spacing:.33em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 199.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ten")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(304.35 199.49) scale(.96 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Day")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(8.77 49.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 0,
    y: 0
  }, "DO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 124.19,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 184.15,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 236.87,
    y: 0
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 284.03,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 340.84,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 401.32,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 462.16,
    y: 0
  }, "AS"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 582.15,
    y: 0
  }, "A")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeLight);
export default __webpack_public_path__ + "static/media/logotype-light.c3e3185f7e48eb993ff773a10d063465.svg";
export { ForwardRef as ReactComponent };